module.exports = __webpack_public_path__ + "img/fingerprint.e5e92ebd.png";